import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=34298cf3"
import script from "./TagForm.vue?vue&type=script&lang=js"
export * from "./TagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports